export const status = {
    training_completed: "completed",
    waiting: "waiting",
    training_paused: "paused",
    in_training: "running",
    deployed_and_running: "Deployed",
    serving_paused: "Paused",
    serving_ready: "Ready to deploy",
    failed: "failed",
    ab_testing: 'A/B Testing',
}